import { render, staticRenderFns } from "./normal-menu.vue?vue&type=template&id=18984ff9&scoped=true&lang=pug&"
import script from "./normal-menu.vue?vue&type=script&lang=js&"
export * from "./normal-menu.vue?vue&type=script&lang=js&"
import style0 from "./normal-menu.vue?vue&type=style&index=0&id=18984ff9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18984ff9",
  null
  
)

export default component.exports